import {Button, Modal} from 'react-bootstrap'
import React from 'react'
import {IRecipe} from '../../api/IRecipe'
import {useTranslation} from 'react-i18next'

const fillContent = (recipe, t) => {
  return {
    title: t('modal.confirmation'),
    question: `${t('modal.deleteRecipeConfirm')} ${recipe?.name}?`,
    cancel: t('common.cancel'),
    confirm: t('common.delete'),
  }
}
interface IContentConfirmationModal {
  title: string
  question: string
  cancel: string
  confirm: string
}
interface IConfirmationModalProps {
  content?: (recipe: IRecipe, t: any) => IContentConfirmationModal
  show: boolean
  onHide: () => void
  onClick: () => void
  recipe: IRecipe
}

export const ConfirmationModal = ({content, show = false, recipe, onClick, onHide}: IConfirmationModalProps): JSX.Element => {
  const { t } = useTranslation();
  const modalContent = content ? content(recipe, t) : fillContent(recipe, t);

  return (
    <Modal
      size="lg"
      show={show}
      onHide={onHide}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>{modalContent.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>{modalContent.question}</div>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onHide} variant="light">{modalContent.cancel}</Button>
        <Button onClick={onClick}>{modalContent.confirm}</Button>
      </Modal.Footer>
    </Modal>
  )
}
